import { FC } from 'react'
import { Heading } from '@boltenergy-be/design-system'

const TermsDutch: FC = () => {
  return (
    <>
      <Heading as="h2" variant="h3">
        Algemene Voorwaarden voor de levering van elektriciteit en/of aardgas door Bolt Energie bv (hierna “wij”) aan de klant (hierna “u”)
        en de teruglevering van elektriciteit _ 01/02/2021
      </Heading>
      <h3>1. De definities en toepassing Algemene Voorwaarden (hierna “AV”)</h3>
      <p>
        <strong>Bijzondere Voorwaarden</strong>: ons document waarin de prijs, de Teruglevergoeding, de duur en de bijzondere bepalingen van
        de Leveringsovereenkomst en/of de Terugleveringsovereenkomst worden vermeld (hierna “BV”).
        <br />
        <strong>Consument</strong>: iedere natuurlijke persoon die elektriciteit en/of aardgas aankoopt voor doeleinden die buiten zijn
        handels-, bedrijfs-, ambachts- of beroepsactiviteit vallen, tenzij anders bepaald in de toepasselijke regelgeving.
        <br />
        <strong>Kleine Professionele Verbruiker</strong>: iedere natuurlijke persoon of rechtspersoon die elektriciteit en/of aardgas
        aankoopt gedeeltelijk of uitsluitend voor professionele doeleinden, en waarvan het jaarlijks verbruik voor al zijn Leverpunten samen
        minder dan 50 MWh elektriciteit en minder dan 100 MWh aardgas bedraagt voor contracten die vóór 1 september 2021 worden gesloten,
        gewijzigd of hernieuwd en minder dan 100 MWh elektriciteit en/of minder dan 100 MWh aardgas voor contracten die vanaf 1 september
        2021 worden gesloten, gewijzigd of hernieuwd.
        <br />
        <strong>Levering</strong>: het voorzien op het Leverpunt van elektriciteit en/of aardgas.
        <br />
        <strong>Leveringsovereenkomst</strong>: het geheel van de overeenkomst tussen u en ons betreffende de Levering; de AV, de BV evenals
        elke schriftelijke aanvulling of aanpassing daarvan maken deel uit van deze Leveringsovereenkomst; in geval van tegenstrijdigheden
        hebben de BV voorrang.
        <br />
        <strong>Leverpunt</strong>: het overeengekomen punt waar wij elektriciteit en/of aardgas leveren en waar u desgevallend ook
        elektriciteit teruglevert aan Bolt; dit punt heeft een uniek EAN-nummer.
        <br />
        <strong>Netbeheerder</strong>: de beheerder van het nationaal, regionaal of lokaal net voor de transmissie, het vervoer of de
        distributie van elektriciteit en/of aardgas.
        <br />
        <strong>Nettarieven</strong>: de tarieven voor het gebruik van het distributie-, lokaal transport- en/of transmissienet voor
        elektriciteit en aardgas.
        <br />
        <strong>Producent Elektriciteit</strong>: de door Bolt aangeboden en door u gekozen producent van lokale en groene elektriciteit.
        <br />
        <strong>Teruglevering</strong>: de verkoop van door de klant geproduceerde en op het Leverpunt geïnjecteerde elektriciteit aan Bolt.
        <br />
        <strong>Terugleveringsovereenkomst</strong>: het geheel van de overeenkomst tussen u en ons betreffende de Teruglevering; de AV, de
        BV evenals elke schriftelijke aanvulling of aanpassing daarvan maken deel uit van deze Leveringsovereenkomst en/of
        Terugleveringsovereenkomst; in geval van tegenstrijdigheden hebben de BV voorrang.
        <br />
        <strong>Terugleveringsvergoeding</strong>: de vergoeding die Bolt aan de klant betaalt voor de door hem geproduceerde en op het
        Leverpunt geïnjecteerde elektriciteit.
      </p>
      <p>
        De begrippen die niet in deze Leveringsovereenkomst en/of Terugleveringsovereenkomst zijn gedefinieerd, hebben de betekenis zoals
        vastgelegd in de toepasselijke regelgeving (inclusief de technische reglementen). Voor meer uitleg over de regionale regelgevingen
        verwijzen wij naar de websites van de bevoegde regulatoren.
      </p>
      <p>
        Deze AV zijn van toepassing op de levering van elektriciteit en aardgas aan Consumenten en aan Kleine Professionele Verbruikers.
        Door de Leveringsovereenkomst te ondertekenen, stemt u in met deze AV.
      </p>
      <h3>2. Leveringsovereenkomst</h3>
      <p>
        2.1. Wij zullen elektriciteit en/of aardgas leveren zoals in de Leveringsovereenkomst bepaald. U zal op het Leverpunt onze
        elektriciteit en/of aardgas afnemen, ons de overeengekomen prijs betalen en de andere bepalingen van de Leveringsovereenkomst
        naleven. De Leveringsovereenkomst doet geen afbreuk aan de wettelijke bepalingen, o.m. inzake openbare dienstverplichtingen.
      </p>
      <p>
        2.2. Indien wij ten gevolge van wijzigingen in het regelgevend kader of door andere buiten onze invloed liggende omstandigheden niet
        voldoende uit hernieuwbare bronnen opgewekte duurzame energie beschikbaar hebben, kunnen we de levering aanvullen met andersoortige,
        maar wel zoveel mogelijk duurzaam opgewekte energie.
      </p>
      <h3>3. Terugleveringsovereenkomst</h3>
      <p>
        3.1. U kan enkel een Terugleveringsovereenkomst sluiten met Bolt als u ook een Leveringsovereenkomst met Bolt heeft afgesloten en u
        beschikt over een digitale meter op het Leverpunt. Een digitale meter meet uw afname en injectie van elektriciteit afzonderlijk en
        kan vanop afstand worden uitgelezen.
      </p>
      <p>
        3.2. Als wij een Terugleveringsovereenkomst sluiten, betaalt Bolt u een vergoeding voor de elektriciteit die u zelf produceert en
        injecteert op het Leverpunt. Deze vergoeding wordt bepaald in de BV.
      </p>

      <h3>4. Totstandkoming van de Leveringsovereenkomst en/of Terugleveringsovereenkomst</h3>
      <p>
        4.1. De Leveringsovereenkomst en/of de Terugleveringsovereenkomst komt tot stand zodra u ons aanbod heeft aanvaard en onder de
        opschortende voorwaarde van bevestiging door de netbeheerder van uw gegevens.
      </p>
      <p>
        4.2. Indien de Leveringsovereenkomst en/of de Terugleveringsovereenkomst met u op afstand wordt gesloten (bv. via onze website of de
        telefoon) of buiten de verkoopruimten van onze onderneming (bv. op evenementen, via deur-aan-deur verkoop) en u een Consument bent,
        zal de Leveringsovereenkomst en/of Terugleveringsovereenkomst u schriftelijk (per brief of per e-mail) worden bevestigd.
      </p>
      <p>
        4.3. Voor zover toegelaten door en overeenkomstig de toepasselijke regelgeving, kunnen wij u als klant weigeren indien wij
        objectieve redenen hebben om te twijfelen aan uw kredietwaardigheid. Bovendien kunnen wij van u, voor zover toegelaten door en
        overeenkomstig de toepasselijke regelgeving, een waarborg vragen in de volgende gevallen:
      </p>
      <ol type="a">
        <li>u heeft nog openstaande schulden bij ons (in welk geval u tevens eerst uw schulden moet aflossen); en/of</li>
        <li>
          in een periode van 24 maanden voorafgaand aan het afsluiten van de Leveringsovereenkomst of tijdens de duur van de
          Leveringsovereenkomst heeft u twee of meerdere facturen niet tijdig betaald.
        </li>
      </ol>
      <p>
        Indien u niet voldoet aan de vraag tot waarborg binnen een termijn van 15 kalenderdagen, kunnen wij u eveneens als klant weigeren.
      </p>
      <p>
        De waarborg zal hoogstens 3 maanden geschat verbruik bedragen, en mag door ons worden gebruikt om uw schulden aan te zuiveren. De
        waarborg zal eventueel na compensatie met nog openstaande bedragen, overeenkomstig de toepasselijke regelgeving, worden teruggestort
        binnen de 30 kalenderdagen na onze eindfactuur. In alle gevallen kan u de waarborg terugvragen van zodra u gedurende één jaar al uw
        facturen stipt heeft betaald zonder betalingsherinnering en u bij ons geen openstaande schuld meer heeft, tenzij de toepasselijke
        regelgeving anders bepaalt.
      </p>
      <p>
        4.4. De Levering en/of Teruglevering start zodra wij door de Netbeheerder als leverancier voor het Leverpunt en/of, in geval van
        Teruglevering, als koper van de door de klant op het Leverpunt geïnjecteerde elektriciteit in het aansluitingsregister of
        toegangsregister werden geregistreerd. Indien u een Consument bent en de Leveringsovereenkomst en/of de Terugleveringsovereenkomst
        op afstand of buiten de verkoopruimten van onze onderneming of onze partners werd gesloten, start de Levering en/of Teruglevering
        ten vroegste na afloop van de herroepingstermijn, tenzij u ons uitdrukkelijk verzoekt om de levering van elektriciteit en/of aardgas
        reeds te laten beginnen tijdens de herroepingstermijn voorzien in artikel 5.1.
      </p>
      <p>
        4.5. Consumenten die bij het afsluiten van de Leveringsovereenkomst en/of Terugleveringsovereenkomst nog gebonden zijn door een
        leveringsovereenkomst en/of terugleveringsovereenkomst met een andere leverancier met betrekking tot het Leverpunt, geven ons een
        uitdrukkelijk mandaat om voor hen deze leveringsovereenkomst en/of terugleveringsovereenkomst te beëindigen. Klanten die nog
        gebonden zijn door een terugleveringsovereenkomst met een andere partij dan een leverancier (zoals een aggregator), doen zelf het
        nodige om deze te beëindigen en het bewijs hiervan aan Bolt te bezorgen.
      </p>
      <h3>5. Herroepingsrecht</h3>
      <p>
        5.1. Als u een Consument bent, heeft u het recht om af te zien van deze Leveringsovereenkomst en/of Terugleveringsovereenkomst,
        zonder betaling van een boete en zonder opgave van motief, en dit binnen een herroepingstermijn die verstrijkt 14 kalenderdagen
        vanaf de ontvangst van de bevestiging van de Leveringsovereenkomst en/of Terugleveringsovereenkomst vanwege Bolt, of indien de
        Leveringsovereenkomst en/of Terugleveringsovereenkomst per telefoon wordt gesloten, vanaf de datum van bevestiging van de
        Leveringsovereenkomst en/of Terugleveringsovereenkomst door u. Om dit herroepingsrecht uit te oefenen, moet u Bolt via een
        ondubbelzinnige schriftelijke verklaring (bijvoorbeeld per post, fax of e-mail) op de hoogte stellen van deze beslissing. U kunt
        hiervoor gebruik maken van het modelformulier voor herroeping dat aangehecht is aan deze AV.
      </p>
      <p>
        5.2. Als u uitdrukkelijk heeft verzocht om de levering van elektriciteit en/of aardgas te laten beginnen tijdens de
        herroepingstermijn, betaalt u een bedrag dat evenredig is aan wat reeds geleverd is op het moment dat u ons in kennis stelt dat u de
        Leveringsovereenkomst herroept. Als u ervoor heeft gekozen om ook uw Terugleveringsovereenkomst te laten beginnen tijdens de
        herroepingstermijn, betaalt Bolt u een Terugleveringvergoeding voor de elektriciteit die u heeft geïnjecteerd op het Leverpunt vanaf
        de startdatum van de Terugleveringsovereenkomst tot op het moment dat u ons in kennis stelt dat u de Terugleveringsovereenkomst
        herroept.
      </p>
      <h3>6. Duur</h3>
      <p>
        6.1. De Leveringsovereenkomst en/of Terugleveringsovereenkomst wordt afgesloten voor bepaalde of onbepaalde duur. Of uw
        Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde of onbepaalde duur is, wordt vermeld in de BV.
      </p>
      <p>
        6.2. Is uw Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde duur, dan wordt/worden deze na afloop in principe
        telkens automatisch verlengd voor de duur vermeld in de BV, tenzij anders bepaald in de BV. Wij kunnen u ten minste twee maanden
        vóór de einddatum van de lopende duur meedelen dat wij de Leveringsovereenkomst en/of de Terugleveringsovereenkomst niet wensen te
        verlengen. Wij kunnen u bij die gelegenheid wel een nieuw voorstel van leveringsovereenkomst en/of terugleveringsovereenkomst
        bezorgen. U kunt ook zelf afzien van de verlenging door ons dit ten minste één maand vóór de einddatum van de lopende duur
        schriftelijk (per brief of per e-mail) mee te delen.
      </p>
      <p>
        6.3. U kan uw Leveringsovereenkomst en/of Terugleveringsovereenkomst van bepaalde of onbepaalde duur op ieder moment zonder kosten
        schriftelijk (per brief of per e-mail) opzeggen, mits naleving van een opzegtermijn van ten minste één maand. De afsluiting van het
        Leverpunt of de kennisgeving van de wijziging van leverancier via de Netbeheerder wordt, voor dit Leverpunt, beschouwd als een
        opzegging van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst door u.
      </p>
      <p>
        6.4. Wij kunnen de Leveringsovereenkomst en/of Terugleveringsovereenkomst van onbepaalde duur op elk moment beëindigen mits het
        respecteren van een opzegtermijn van twee maanden.
      </p>
      <p>
        6.5. De Leveringsovereenkomst loopt in alle gevallen door zolang Bolt in het toegangsregister vermeld staat als de verantwoordelijke
        voor de bevoorrading op uw Leverpunt.
      </p>
      <h3>7. Verbruik, Levering en Meting</h3>
      <p>7.1. Verbruik</p>
      <p>7.1.1. U zal de elektriciteit en/of het aardgas enkel op het Leverpunt verbruiken en niet doorleveren aan derden.</p>
      <p>
        7.1.2. Indien u toestellen gebruikt om zelf energie te produceren, dient u dit onmiddellijk aan ons te melden. Als u dit wenst, kan
        u voor de door u op het net geïnjecteerde elektriciteit een Terugleveringsovereenkomst met Bolt sluiten.
      </p>
      <p>7.2. Levering en Netbeheerder</p>
      <p>
        7.2.1. U sluit met ons de Leveringsovereenkomst en/of de Terugleveringsovereenkomst. Uw aansluiting op het net wordt door de
        Netbeheerder beheerd. De Netbeheerder is verantwoordelijk voor het functioneren van het net en de continuïteit van de Levering en de
        Teruglevering, en regelt de kwaliteit van de afname, de toevoer van elektriciteit en/of aardgas, de meetinrichting, de voor de
        aansluiting van de installaties relevante technische bepalingen evenals het aan- en afsluiten van de meters. Wij zijn geen partij
        bij deze relatie en zijn derhalve niet verantwoordelijk voor het nakomen van regels in die relatie door u of door de Netbeheerder.
      </p>
      <p>
        7.2.2. Indien de Netbeheerder de toevoer van elektriciteit en/of aardgas en/of de injectie van elektriciteit op het net beperkt of
        onderbreekt, zal de Levering en/of de Teruglevering automatisch eveneens beperkt of onderbroken worden. Deze beperking en/of
        schorsing valt buiten onze aansprakelijkheid.
      </p>
      <p>7.3. Meting</p>
      <p>
        7.3.1. De Netbeheerder bezorgt ons de stand van uw meter. Indien u ons de stand meedeelt, bent u verantwoordelijk voor de juiste
        opgave daarvan. De gegevens van de Netbeheerder hebben in elk geval voorrang.
      </p>
      <p>
        7.3.2. Zowel u als wij kunnen bij twijfel over de juistheid van de meting de meetinstallatie laten onderzoeken. Dit gebeurt op
        kosten van de verzoeker.
      </p>
      <p>
        7.3.3. Een rechtzetting van de meetgegevens en de daaruit voortvloeiende facturatie kan betrekking hebben op een periode van
        maximaal twee jaar voorafgaand aan de laatste meteropname, tenzij de toepasselijke regelgeving hierover iets anders zou bepalen.
      </p>
      <h3>8. Prijs en kosten</h3>
      <p>
        8.1. De prijs die u aan Bolt verschuldigd bent voor de Levering, bestaat uit (1) de energieprijs zoals bepaald in de BV, en (2) de
        andere bestanddelen van de prijs zoals bepaald in artikel 8.2.
      </p>
      <p>8.2. Tenzij anders bepaald wordt in de BV, wordt de energieprijs verhoogd met:</p>
      <ul>
        <li>
          de BTW, belastingen, heffingen, retributies, bijdragen, toeslagen, vergoedingen, en eventuele andere lasten en kosten die ons door
          de bevoegde overheid of reguleringsinstantie worden opgelegd;
        </li>
        <li>
          de Nettarieven, meterhuurkosten, de kosten voor de aan- of afsluiting van het Leverpunt, de eventuele bijkomende netdiensten, het
          reactief vermogen en het piekvermogen die ons opgelegd worden door de Netbeheerder.
        </li>
        <li>
          De kosten van de wettelijke verplichtingen om groene stroom-, groene warmte-, warmtekracht- en/of analoge certificaten voor te
          leggen.
        </li>
      </ul>
      <p>
        Deze bestanddelen worden rechtstreeks aan u doorgerekend, met inbegrip van de wijzigingen die buiten de verantwoordelijkheid van
        Bolt vallen, ook met terugwerkende kracht.
      </p>
      <p>
        8.3. Wij mogen alle kosten aan u aanrekenen die ons door de Netbeheerder aangerekend worden voor diensten uitgevoerd op uw vraag, op
        initiatief van de Netbeheerder of op onze vraag ten gevolge van uw nalaten of fout. Eveneens mogen wij bovenop deze kosten onze
        administratieve kosten aan u aanrekenen.
      </p>
      <p>8.4. De Terugleveringsvergoeding die Bolt aan u is verschuldigd voor de Teruglevering, wordt bepaald in de BV.</p>
      <h3>9. Facturatie en betalingsvoorwaarden</h3>
      <p>
        9.1. Wij baseren ons conform artikel 7.3 op de meetgegevens die ons ter beschikking worden gesteld en op de door de Netbeheerder
        meegedeelde verbruiksprofielen om de door u afgenomen elektriciteit en/of aardgas te factureren. Wij sturen u maandelijkse
        voorschotfacturen. De hoogte van die voorschotfacturen wordt door ons bepaald op basis van de door u verstrekte gegevens of op basis
        van de periodieke afrekening, met dien verstande dat u ons mag verzoeken de hoogte van de voorschotfacturen te herzien. In dat geval
        zullen wij u binnen een redelijke termijn informeren of wij aan uw verzoek gevolg kunnen geven. Voor zover wij uw meetgegevens
        hebben ontvangen van de Netbeheerder, bezorgen wij u jaarlijks een factuur waarin uw effectieve verbruik wordt afgerekend en waarin
        wij de reeds gefactureerde voorschotfacturen tot meteropname verrekenen. Indien wij geen meetgegevens ontvangen, kunnen wij u
        voorschotfacturen blijven sturen. Indien wij geschatte verbruiken ontvangen van de Netbeheerder, dan zullen wij dit geschatte
        verbruik effectief aanrekenen. Indien wij vaststellen dat de verbruiksgegevens foutief zijn, zullen wij dit melden aan de
        Netbeheerder en zullen wij u verder voorschotfacturen sturen. Uw effectieve verbruik zal dan later worden afgerekend.
      </p>
      <p>
        9.2. De betaling van onze facturen kan uitsluitend gebeuren op ons bankrekeningnummer vermeld op de factuur. U dient onze facturen
        uiterlijk binnen de 15 kalenderdagen na ontvangstdatum (indien de factuur wordt verstuurd per post, wordt deze geacht te zijn
        ontvangen op de derde dag na de verzending) te betalen. Indien u de factuur niet tijdig betaalt, zullen wij u minstens één
        herinnering sturen. Bij gebreke aan betaling binnen de in de herinnering voorziene termijn, sturen wij u een ingebrekestelling.
      </p>
      <p>
        Indien wij u een bedrag verschuldigd zijn, zullen we dit (terug)betalen binnen de betalingstermijn zoals bepaald in het eerste lid,
        tenzij:
      </p>
      <ol type="a">
        <li>
          wij niet op de hoogte zijn van uw rekeningnummer (in welk geval wij de (terug)betaling zullen doen binnen de 15 kalenderdagen
          nadat wij op de hoogte werden gebracht van uw rekeningnummer); of
        </li>
        <li>u nog openstaande facturen heeft, waarbij wij het recht hebben dit te compenseren overeenkomstig de bestaande regelgeving.</li>
      </ol>
      <p>
        Er wordt geen bijkomende kost aangerekend indien u zich verzet tegen domiciliëring. U heeft de mogelijkheid om uw
        -afrekeningsfacturenen eindfactuur uit te sluiten van domiciliëring. De uitvoering van de domiciliëringsopdracht van de eindfactuur
        zal ten vroegste 15 kalenderdagen na datum van ontvangst van de eindfactuur gebeuren (de datum van ontvangst is de derde dag na het
        versturen van de factuur indien ze per post werd verstuurd en dezelfde dag als ze verstuurd werd per e-mail).
      </p>
      <p>
        9.3. De eventuele Terugleveringsvergoeding die Bolt u verschuldigd is voor de door u geïnjecteerde elektriciteit, wordt in onze
        afrekeningsfacturen en eindfactuur verrekend met de prijs die u aan Bolt verschuldigd bent voor de levering van de door u verbruikte
        elektriciteit. U betaalt het saldo aan Bolt of Bolt betaalt het saldo aan u, naargelang het geval.
      </p>
      <p>
        9.4. Indien u of wij van mening zijn dat onze factuur foutieve gegevens (andere dan de meetgegevens) bevat, moet binnen de 12
        maanden na ontvangst van de factuur schriftelijk contact met de andere partij worden opgenomen, behoudens wanneer de toepasselijke
        regelgeving een langere termijn voorziet. Indien de klacht over een factuur terecht is of verder moet worden onderzocht en indien de
        betreffende factuur nog niet werd betaald, mag u de betaling van het betwiste deel van de factuur opschorten tot de klacht is
        afgehandeld. Wij zullen zo vlug mogelijk na ontvangst van de klacht (of zo vlug mogelijk na ontvangst van de noodzakelijke
        informatie van een derde indien wij die informatie nodig hebben voor het beantwoorden van de klacht) ten gronde op de klacht
        antwoorden.
      </p>
      <p>
        9.5. Laattijdige betaling van één factuur door u heeft alsgevolg dat iedere andere factuur, ook al was daarvoor door ons een
        afbetalingsplan toegestaan, onmiddellijk opeisbaar is, zonder ingebrekestelling.
      </p>
      <p>
        9.6. Voor zover toegelaten door en overeenkomstig de toepasselijke regelgeving mogen wij administratieve kosten aanrekenen voor het
        toezenden van extra facturen, duplicaten, een afbetalingsplan, brieven ingevolge uw laattijdige betaling of indien een opdracht tot
        domiciliëring door de bank- en/of postinstelling wordt geweigerd. De kostprijs bedraagt tot 8 EUR voor een herinneringsbrief en 20
        EUR voor een ingebrekestelling, behoudens wanneer de toepasselijke regelgeving andere bedragen voorziet.
      </p>
      <p>
        9.7. Bij niet-tijdige betaling van de gehele factuur of een deel ervan of indien een opdracht tot domiciliëring door de financiële
        instelling wordt geweigerd, bent u van rechtswege en zonder ingebrekestelling of herinnering gehouden tot betaling van
        verwijlinteresten. De verwijlinteresten worden berekend op basis van de wettelijke interestvoet als u een Consument bent en op basis
        en op basis van de interestvoet bepaald in de wet betreffende de bestrijding van de betalingsachterstand bij handelstransacties van
        augustus 2002 als u een Kleine Professionele Verbruiker bent. De verwijlinteresten worden aangerekend vanaf de vervaldag, op elk
        onbetaald gelaten bedrag tot de datum van volledige betaling. Daarenboven bent u, bij gebreke aan volledige betaling nadat wij uw
        onbetaalde factu(u)r(en) hebben overgemaakt aan een derde (bv. gerechtsdeurwaarder, advocaat of incassokantoor), van rechtswege en
        zonder verdere ingebrekestelling een forfaitaire schadeloosstelling verschuldigd van 10 % op elk onbetaald gelaten factuurbedrag,
        met een minimum van 55 EUR, dit ter vergoeding van de buitengerechtelijke invorderingskosten, in overeenstemming met de
        toepasselijke regelgeving, onverminderd ons recht om grotere schade en nadelen te bewijzen, onder meer door aanrekening van
        procedurekosten.
      </p>
      <p>
        9.8. Tenzij de gewestelijke reglementering een andere schadevergoeding zou voorzien, heeft u recht op verwijlinteresten op elk
        onbetaald gelaten bedrag aan de wettelijke interestvoet ingevolge foutieve facturatie door onze fout of onze laattijdige
        (terug)betaling. Deze interesten beginnen te lopen de dag na de dag waarop wij de betaling conform artikel 9.2 hadden moeten
        uitvoeren, of, in geval van foutieve facturatie door onze fout, vanaf de datum van protest door u, tot de datum van volledige
        betaling door ons. Tevens zijn dan de kosten van uw ingebrekestellingen en herinneringen voor onze rekening. Daarenboven heeft u
        recht op een forfaitaire schadeloosstelling van 10% van het dan onbetaalde bedrag voor zover u een derde (bv. gerechtsdeurwaarder,
        advocaat of incassokantoor) moet inschakelen om betaling ervan te bekomen met een minimum van 55 EUR, dit ter vergoeding van de
        buitengerechtelijke invorderingskosten, in overeenstemming met de toepasselijke regelgeving, onverminderd uw recht om grotere schade
        en nadelen te bewijzen, onder meer door aanrekening van procedurekosten.
      </p>
      <p>9.9. Indien de Leveringsovereenkomst wordt beëindigd, om welke reden ook, bezorgen wij u een eindafrekening.</p>
      <p>
        9.10. Indien u meent recht te hebben op het statuut van beschermde klant of op het sociaal tarief en dit niet automatisch wordt
        toegepast, moet u ons zo snel als mogelijk de nodige bewijzen en stukken bezorgen.
      </p>
      <h3>10. Aansprakelijkheid</h3>
      <p>
        10.1. Zonder afbreuk te doen aan de overige bepalingen inzake aansprakelijkheid in deze Leveringsovereenkomst en/of
        Terugleveringsovereenkomst en in de toepasselijke regelgeving, zijn u en wij ten opzichte van elkaar enkel aansprakelijk in geval
        van: (a) niet-uitvoering van de voornaamste verbintenissen van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst, tenzij
        in geval van overmacht; (b) bedrog, grove of opzettelijke fout; (c) overlijden of lichamelijk letsel van u veroorzaakt door een
        handeling of nalaten van Bolt.
      </p>
      <p>
        10.2. In geval van aansprakelijkheid zal enkel de rechtstreeks veroorzaakte materiële schade vergoed worden. Enige vergoeding van
        immateriële schade zoals onder andere bedrijfsschade, winstderving, productieverlies, verlies van gegevens of verlies van inkomsten
        is uitdrukkelijk uitgesloten. De vergoeding van alle materiële schade zal bovendien maximaal gelijk zijn aan 12 maal uw gemiddelde
        maandverbruik van de laatste zes maanden, of van de duur van de Leveringsovereenkomst en/of Terugleveringsovereenkomst zo deze
        korter is. Deze beperking is niet van toepassing in geval van overlijden of lichamelijk letsel van u veroorzaakt door een handeling
        of nalaten van Bolt.
      </p>
      <p>
        10.3. Elke aanspraak op schadevergoeding moet binnen 30 kalenderdagen na de datum waarop de schade is ingetreden of na de datum
        waarop de schade redelijkerwijs vastgesteld had kunnen worden, schriftelijk aan de andere partij worden gemeld. Laattijdige
        schademeldingen worden niet vergoed.
      </p>
      <p>
        10.4. Wij zijn niet aansprakelijk voor de schade veroorzaakt door het niet goed functioneren van het net, de installaties op het
        Leverpunt, de meetinrichting, fouten in meetgegevens, variaties in spanning en frequentie, tekortkomingen van de Netbeheerder, noch
        voor de gevolgen van het niet-nakomen van de afspraken tussen u en de Netbeheerder. Evenmin zijn wij aansprakelijk voor de kwaliteit
        van de uitgewisselde gegevens (zoals bijvoorbeeld standaard jaarverbruiken, synthetische lastprofielen). Dit alles is de
        verantwoordelijkheid van de Netbeheerder en staat los van de Leveringsovereenkomst en/of Terugleveringsovereenkomst.
      </p>
      <p>10.5. U zal ons vrijwaren voor eventuele vorderingen van derden, zoals uw commerciële relaties.</p>
      <h3>
        11. Schorsing van de Levering en/of Teruglevering en onmiddellijke beëindiging van de Leveringsovereenkomst en/of
        Terugleveringsovereenkomst
      </h3>
      <p>
        11.1. In geval van ernstige tekortkoming door ons, mag u de Leveringsovereenkomst en/of Terugleveringsovereenkomst vroegtijdig
        beëindigen per aangetekende brief met onmiddellijke ingang en zonder rechterlijke tussenkomst.
      </p>
      <p>
        11.2. Wij mogen de Levering en/of de Teruglevering schorsen of de Leveringsovereenkomst en/of de Terugleveringsovereenkomst
        vroegtijdig beëindigen per schriftelijke kennisgeving met onmiddellijke ingang, zonder rechterlijke tussenkomst en zonder
        schadevergoeding, mits naleving van de toepasselijke regelgeving, indien:
      </p>
      <ol type="a">
        <li>u uw betalingsverplichtingen of andere verplichtingen na ingebrekestelling niet nakomt;</li>
        <li>wij u conform artikel 4.3 vragen om een waarborg te stellen, en u nalaat om (tijdig) deze waarborg te stellen;</li>
        <li>
          er een onderbreking of stopzetting van de Levering en/of de Teruglevering wordt opgelegd door de Netbeheerder of een bevoegde
          overheid;
        </li>
        <li>u fraudeert of door ons geleverde elektriciteit en/of aardgas doorlevert aan derden;</li>
        <li>
          u nalaat ons onmiddellijk in te lichten over ieder element waarvan u kennis heeft dat de uitvoering van de Leveringsovereenkomst
          en/of de Terugleveringsovereenkomst kan verhinderen of bemoeilijken.
        </li>
      </ol>
      <p>
        De beëindiging doet geen afbreuk aan ons recht op schadevergoeding. In geval van beëindiging overeenkomstig artikel 11.2 (d), zal
        deze schadevergoeding minstens gelijk zijn aan 3 maanden geschat verbruik. Indien onze schade groter is, zullen wij ook die kunnen
        verhalen. Onverminderd hetgeen bepaald is in artikel 9.5 en 9.6, bent u evenwel geen schadevergoeding verschuldigd indien wij
        beëindigen op grond van artikel 11.2. (a), (b) of (c).
      </p>
      <p>
        11.3. In geval van een vroegtijdige beëindiging van de Leveringsovereenkomst door u of door ons, wordt de Leveringsovereenkomst
        steeds in zijn geheel beëindigd, m.a.w. voor zowel elektriciteit als voor aardgas. Desgevallend kan er daarna een nieuwe
        Leveringsovereenkomst worden gesloten voor elektriciteit of aardgas.
      </p>
      <p>
        11.4. Wanneer de Terugleveringsovereenkomst, al dan niet vroegtijdig, wordt beëindigd door u of door ons, heeft dit geen impact op
        de Leveringsovereenkomst, tenzij anders aangegeven door u of door ons. Wanneer de Terugleveringsovereenkomst, al dan niet
        vroegtijdig, wordt beëindigd door u of door ons, wordt de Leveringsovereenkomst ook beëindigd.
      </p>
      <p>
        11.5 De Leveringsovereenkomst loopt in alle gevallen door zolang Bolt in het toegangsregister vermeld staat als de verantwoordelijke
        voor de bevoorrading op uw Leverpunt.
      </p>
      <h3>12. Verhuis / overdracht</h3>
      <p>
        12.1. Bij verhuis blijft de Leveringsovereenkomst onverminderd van kracht op uw nieuwe adres. U dient ons bij voorkeur 30
        kalenderdagen op voorhand (en uiterlijk 30 kalenderdagen na de verhuisdatum voor Consumenten en 10 kalenderdagen erna voor Kleine
        Professionele Verbruikers) op de hoogte te brengen van uw verhuisplannen en ons volgende informatie te bezorgen:
      </p>
      <ol type="a">
        <li>uw toekomstige adres;</li>
        <li>EAN-nummer(s) en meternummer op dat adres;</li>
        <li>
          de datum vanaf wanneer er geleverd moet worden op het nieuwe Leverpunt en de Levering op uw huidige Leverpunt gestopt dient te
          worden; en de meterstanden van uw oude en nieuwe adres op het ogenblik van de verhuisdatum.
        </li>
      </ol>
      <p>
        U kan hiervoor gebruik maken van de communicatiekanalen die wij met het oog op verhuis ter beschikking stellen, o.a. ons
        energieovernamedocument.
      </p>
      <p>
        12.2. Indien u ons niet binnen de termijn bepaald in artikel 12.1 op de hoogte stelt van uw verhuis, blijft de Leveringsovereenkomst
        gelden op uw oude adres. Dit betekent dat u gehouden bent om alle elektriciteit en/of aardgas moet betalen die – door wie dan ook -
        wordt afgenomen op het Leverpunt dat u verlaat, tenzij de toepasselijke regelgeving in een andersluidende dwingende regeling
        voorziet. Indien u ons niet binnen de termijn bepaald in artikel 12.1 op de hoogte stelt van uw verhuis, neemt de
        Terugleveringsovereenkomst automatisch een einde op het moment van uw verhuis. Eventuele elektriciteit die – door wie dan ook –
        wordt geïnjecteerd op het Leverpunt dat u verlaat, wordt niet vergoed door Bolt, tenzij de toepasselijke regelgeving in een
        andersluidende dwingende regeling voorziet.
      </p>
      <p>
        12.3. Wij bezorgen u een factuur met de eindafrekening voor het Leverpunt dat u verlaat. Indien u ons niet binnen de termijn bepaald
        in artikel 12.1 de meterstand van het Leverpunt dat u verlaat, bezorgt, dan hebben wij het recht om de meterstand te laten
        vaststellen door de Netbeheerder op uw kosten.
      </p>
      <p>
        12.4. Indien u, mits voorlegging van het bewijs, verhuist naar het buitenland of naar een ander gewest, naar een woning waar er geen
        aparte meter is voor elektriciteit- en/of aardgasverbruik, gaat inwonen bij een andere verbruiker die reeds een
        leveringsovereenkomst (met ons of met een andere leverancier) heeft, verhuist naar een gebied waar wij om objectieve redenen niet
        (meer) in staat zijn om de Leveringsovereenkomst en/of de Terugleveringsovereenkomst verder te zetten, kan de Leveringsovereenkomst
        en/of de Terugleveringsovereenkomst door u of door ons opgezegd worden met ingang van de effectieve verhuisdatum.
      </p>
      <p>
        12.5. Wij leveren op uw nieuwe Leverpunt vanaf de datum die u ons meedeelde. De BV van de Leveringsovereenkomst en/of de
        Terugleveringsovereenkomst kunnen worden aangepast zoals voorzien in artikel 13 en/of in functie van uw nieuwe Netbeheerder.
      </p>
      <p>
        12.6. Indien u de bovenstaande verplichtingen bij uw verhuis niet naleeft, geeft u ons een mandaat om bij de netbeheerder de
        sluiting van de meter op het Leverpunt dat u verlaat, te vragen. U staat dan in voor alle kosten van de sluiting. Wij zijn niet
        aansprakelijk voor de schade die in dat geval wordt veroorzaakt.
      </p>
      <h3>13. Wijzigingen aan de Leveringsovereenkomst en/of Terugleveringsovereenkomst</h3>
      <p>
        13.1. Voor zover deze wijzigingen niet in uw nadeel zijn, mogen wij op elk moment wijzigingen aanbrengen aan de
        Leveringsovereenkomst en/of de Terugleveringsovereenkomst. Wij zullen u desgevallend deze gewijzigde voorwaarden ten minste twee
        maanden voor het inwerkingtreden ervan op geïndividualiseerde wijze meedelen. Als mededeling geldt onder meer de melding per brief,
        op de factuur, per e-mail of via een andere duurzame drager.
      </p>
      <p>
        13.2. Indien uw Leveringsovereenkomst en/of uw Terugleveringsovereenkomst van onbepaalde duur is, kunnen wij bovendien op elk
        moment:
        <br />
        - prijsverhogingen doorvoeren in het geval van een Leveringsovereenkomst;
        <br />
        - de Terugleveringsvergoeding verlagen in het geval van een Terugleveringsovereenkomst;f
        <br />
        - of wijzigingen in uw nadeel aanbrengen
        <br />
        mits wij u hiervan minstens twee maanden voor het inwerkingtreden ervan informeren op dezelfde wijze als bepaald in artikel 13.1.
      </p>
      <p>
        U zal geacht worden deze wijzigingen aanvaard te hebben, tenzij u binnen de maand na ontvangst van de mededeling de
        Leveringsovereenkomst (in geval van wijzigingen aan de Leveringsovereenkomst) en/of de Terugleveringsovereenkomst (in geval van
        wijzigingen aan de Terugleveringsovereenkomst) opzegt conform artikel 6.3. In geval van mededeling per e-mail, is de dag van
        ontvangst de dag van verzending van de e-mail; indien de mededeling wordt verstuurd per post, wordt deze geacht te zijn ontvangen op
        de derde dag na de verzending.
      </p>
      <p>
        13.3. Indien uw Leveringsovereenkomst wordt verlengd overeenkomstig artikel 6.2, kunnen wij u evenwel twee maanden vóór de
        verlenging voorstellen om de prijzen en/of voorwaarden van de Leveringsovereenkomst voor de volgende periode te wijzigen. Indien u
        schriftelijk instemt met de wijzigingen, zal de Leveringsovereenkomst voor de volgende periode worden voortgezet volgens deze
        wijzigingen. Indien u dit niet doet en u ook niet van leverancier bent veranderd bij afloop van de lopende duur, zullen wij u
        blijven leveren aan de prijzen en voorwaarden van ons goedkoopste equivalent product van bepaalde duur.
      </p>
      <p>
        13.4. Indien uw Terugleveringsovereenkomst wordt verlengd overeenkomstig artikel 6.2, kunnen wij u evenwel twee maanden vóór de
        verlenging voorstellen om de prijzen en/of voorwaarden van de Terugleveringsovereenkomst voor de volgende periode te wijzigen.
        Indien u schriftelijk instemt met de wijzigingen, zal de Terugleveringsovereenkomst voor de volgende periode worden voortgezet
        volgens deze wijzigingen. Indien u dit niet doet en u ook geen andere leverancier of derde hebt aangeduid als koper van de door uw
        geïnjecteerde elektriciteit, heeft Bolt de keuze om de Terugleveringsovereenkomst te verlengen aan de oude prijzen en voorwaarden
        dan wel om de Terugleveringsovereenkomst niet te verlengen.
      </p>
      <p>
        13.5. Indien, anders dan in artikel 13.1 en 13.2, de Bijzondere Voorwaarden in onderling overleg worden gewijzigd, zal een nieuwe
        Leveringsovereenkomst en/of Terugleveringsovereenkomst tot stand komen zodra wij deze wijziging in onze systemen hebben verwerkt.
        Wij brengen u van deze datum op de hoogte.
      </p>
      <p>
        13.6. Wij mogen de Leveringsovereenkomst en/of de Terugleveringsovereenkomst overdragen aan een derde en zullen u in dat geval
        inlichten. Deze derde zal de Leveringsovereenkomst en/of de Terugleveringsovereenkomst onder dezelfde voorwaarden verder zetten. U
        mag de Leveringsovereenkomst en/of de Terugleveringsovereenkomst niet overdragen aan een derde, een medebewoner of een nieuwe
        bewoner.
      </p>
      <h3>14. Wijziging Producent Elektriciteit</h3>
      <p>
        14.1. De koppeling tussen u en de Producent Elektriciteit is gebaseerd op gemiddelden van uw verbruik en de productie van de
        Producent Elektriciteit. Beperkte schommelingen in uw verbruik en de productie van de Producent Elektriciteit zullen worden
        opgevangen met elektriciteit afkomstig van andere producenten die bij ons platform zijn aangesloten, die eveneens lokale en groene
        elektriciteit produceren.
      </p>
      <p>
        14.2. Indien de Producent Elektriciteit niet meer beschikbaar is op ons platform of structureel niet meer voldoende elektriciteit
        produceert om in uw elektriciteitsverbruik te voorzien (naast dat van de andere klanten die voor deze Producent Elektriciteit hebben
        gekozen), zal Bolt u hiervan schriftelijk op de hoogte brengen per brief of per e-mail. Wij stellen u dan een nieuwe producent voor
        ter vervanging van uw Producent Elektriciteit. Vanaf deze melding, beschikt u over één maand om ons een andere keuze voor een nieuwe
        producent mee te delen via brief of e-mail. Deze termijn van één maand gaat in vanaf de dag van verzending van onze e-mail of vanaf
        de derde dag na de verzending van onze brief. Indien u ons uw keuze voor een andere nieuwe producent niet meedeelt en u ook niet van
        leverancier verandert binnen deze termijn, zullen wij de door ons voorgestelde producent aan u koppelen.
      </p>
      <p>
        14.3. De wijziging van de Producent Elektriciteit overeenkomstig artikel 14.2., zal niet worden beschouwd als een wijziging van de
        Leveringsovereenkomst.
      </p>
      <h3>15. Evenwichtsverantwoordelijkheid</h3>
      <p>Voor de evenwichtsverantwoordelijkheid, zowel voor de Levering als voor de Teruglevering, doet Bolt een beroep op [Luminus NV].</p>
      <h3>16. Overmacht</h3>
      <p>
        16.1. Ingeval van overmacht worden de verplichtingen onder deze Leveringsovereenkomst en/of Terugleveringsovereenkomst, behalve de
        verplichting tot betaling van een geldsom, geschorst of beperkt gedurende de periode van de overmacht. Onder overmacht dient te
        worden verstaan: elke onvoorzienbare en onvermijdbare gebeurtenis die onafhankelijk is van de wil van een partij die een
        onoverkomelijk beletsel uitmaakt voor de nakoming van de verbintenis van die partij, zoals maar niet beperkt tot, uitval van het
        net, problemen in het transport of de distributie, het niet kunnen verkrijgen van (voldoende) elektriciteit of aardgas,
        natuurrampen, stakingen.
      </p>
      <p>
        16.2. Indien de overmachtssituatie meer dan drie maanden aanhoudt, hebben zowel u als wij het recht om de Leveringsovereenkomst
        en/of Terugleveringsovereenkomst schriftelijk te beëindigen, zonder dat schadevergoeding verschuldigd is aan de andere partij.
      </p>
      <h3>17. Bescherming van de persoonlijke levenssfeer</h3>
      <p>
        Als verantwoordelijke voor de verwerking van uw persoonsgegevens, verwerken wij uw persoonsgegevens steeds in overeenstemming met de
        toepasselijke privacyregelgeving. Wij verwerken uw persoonsgegevens voor doeleinden en rechtsgronden beschreven in ons privacybeleid
        zoals vermeld op onze website www.boltenergie.be onder de rubriek “Disclaimer en Privacy Policy” (hierna ‘het Privacybeleid’). Door
        uitdrukkelijk in te stemmen en akkoord te gaan met de Leveringsovereenkomst en/of Terugleveringsovereenkomst, bevestigt u kennis te
        hebben genomen van het Privacybeleid en akkoord te gaan met de verwerking van uw persoonsgegevens overeenkomstig het Privacybeleid.
      </p>
      <h3>18. Geen afstand van recht</h3>
      <p>
        Het niet-aandringen op de uitvoering van enige bepaling van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst, kan niet
        worden opgevat als een afstand van recht of een beperking daarvan.
      </p>
      <h3>19. Onafdwingbare bepalingen</h3>
      <p>
        Indien een bepaling van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst ongeldig of nietig zou zijn, zal dit geen
        invloed hebben op de geldigheid van de andere bepalingen van de Leveringsovereenkomst en/of de Terugleveringsovereenkomst, maar zal
        deze ongeldige of nietige bepaling naar best vermogen vervangen worden door een geldige bepaling die zo nauw mogelijk aansluit bij
        de oorspronkelijke bedoeling van de partijen.
      </p>
      <h3>20. Toepasselijk recht en geschillen – klachten</h3>
      <p>20.1. Het Belgisch recht is van toepassing op de Leveringsovereenkomst en/of de Terugleveringsovereenkomst.</p>
      <p>
        20.2. Voor klachten kan u zich wenden tot onze klantendienst, waarvan u de contactgegevens kan terugvinden op uw factuur of op onze
        website. Indien uw Leveringsovereenkomst en/of Terugleveringsovereenkomst elektronisch werd afgesloten, kan u beroep doen op het
        ODR-platform voor onlinebeslechting van uw geschillen (
        <a href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a>).
      </p>
      <p>
        20.3. Geschillen omtrent de Leveringsovereenkomst en/of de Terugleveringsovereenkomst kunnen naar keuze van de eisende partij worden
        gebracht voor de rechter van de woonplaats van de verwerende partij of voor de rechter van de plaats waar de verbintenis waarop het
        geschil betrekking heeft, is ontstaan of waar zij moet worden uitgevoerd.
      </p>
      <h3>MODELFORMULIER HERROEPING</h3>
      <p>
        Dit formulier alleen invullen en aan Bolt bezorgen als je je Leveringsovereenkomst en/of je Terugleveringsovereenkomst wil
        herroepen.
      </p>
      <p>Gelieve dit document terug te bezorgen aan Bolt:</p>
      <p>Via post: (adres aanvullen)</p>
      <p>Via e-mail: (e-mail aanvullen)</p>
      <p>
        Ik deel u mee dat ik de Leveringsovereenkomst voor de levering van elektriciteit / gas en/of de Terugleveringsovereenkomst voor
        elektriciteit* wil herroepen. (Schrappen wat niet past).
      </p>
      <p>Productnaam:</p>
      <p>Datum bevestiging Leveringsovereenkomst en/of Terugleveringsovereenkomst:</p>
      <p>
        <i>
          In het geval de Leveringsovereenkomst en/of Terugleveringsovereenkomst telefonisch gesloten werd: de datum dat u de
          Leveringsovereenkomst en/of Terugleveringsovereenkomst bevestigd heeft.
        </i>
      </p>
      <p>
        <i>In alle andere gevallen: de datum dat Bolt de Leveringsovereenkomst en/of Terugleveringsovereenkomst bevestigd heeft.</i>
      </p>
      <p>Naam Consument:</p>
      <p>Adres Consument:</p>
      <p>Datum:</p>
      <p>Handtekening:</p>
    </>
  )
}

export default TermsDutch
